export default {
    title: 'Preventivi',
    subtitle: 'Gestisci le richieste di preventivo ricevute via email',
    settingsButton: 'Impostazioni',
    
    list: {
        loading: 'Caricamento preventivi...',
        noQuotes: 'Nessun preventivo trovato',
        searchPlaceholder: 'Cerca preventivi...',
        lastUpdate: 'Ultimo aggiornamento',
        viewAll: 'Visualizza tutti i preventivi',
        filters: {
            allStatuses: 'Tutti gli stati',
        },
        headers: {
            from: 'Da',
            subject: 'Oggetto',
            receivedAt: 'Ricevuto',
            status: 'Stato',
        },
    },
    
    status: {
        pending: 'In attesa',
        autoResponded: 'Risposta automatica',
        requiresReview: 'Richiede revisione',
        responded: 'Risposto',
        archived: 'Archiviato',
        completed: 'Completato',
        cancelled: 'Annullato',
    },
    
    shipperStatus: {
        accepted: 'Accettato da Shipper',
        rejected: 'Rifiutato da Shipper',
        modificationRequested: 'Modifica Richiesta da Shipper',
    },
    
    badges: {
        autoResponded: 'Auto-risposto',
        requiresReview: 'Richiede revisione',
    },
    
    extracted: {
        product: 'Prodotto',
        origin: 'Origine',
        destination: 'Destinazione',
        quantity: 'Quantità',
        unit: 'Unità',
        pickupDate: 'Data ritiro',
        deliveryDate: 'Data consegna',
        estimatedValue: 'Valore stimato',
        equipmentType: 'Tipo equipaggiamento',
        temperatureRequirements: 'Requisiti temperatura',
        specialRequirements: 'Requisiti speciali',
        customsRequirements: 'Requisiti doganali',
    },
    
    detail: {
        tabs: {
            email: 'Email originale',
            extractedData: 'Dati estratti',
            responseEmail: 'Email di risposta',
            createResponse: 'Crea Risposta',
            thread: 'Thread',
        },
        email: {
            from: 'Da',
            receivedAt: 'Ricevuta il',
            respondedAt: 'Risposta inviata il',
            body: 'Corpo email',
        },
        responseEmail: {
            subject: 'Oggetto',
            sentAt: 'Inviata il',
            body: 'Corpo email',
        },
        createResponse: {
            title: 'Crea Email di Risposta',
            subject: 'Oggetto',
            subjectPlaceholder: 'Es. Preventivo per trasporto {{product}}',
            body: 'Corpo Email',
            bodyPlaceholder: 'Inserisci il testo della risposta...',
            bodyHint: 'Usa {{variabile}} per inserire dati dinamici. Puoi fare riferimento ai dati estratti a destra.',
            extractedDataReference: 'Riferimento Dati Estratti',
            saveDraft: 'Salva Bozza',
            send: 'Invia Risposta',
            sending: 'Invio in corso...',
            titleCounterProposal: 'Crea Controproposta',
            successTitle: 'Preventivo inviato con successo',
            successMessage: 'Il preventivo è stato inviato correttamente allo Shipper. Riceverà una notifica e potrà visualizzare la tua proposta nella sezione Quote.',
            price: 'Prezzo',
            pricePlaceholder: '0.00',
            validity: 'Validità (giorni)',
            validityPlaceholder: '30',
            terms: 'Termini e Condizioni',
            termsPlaceholder: 'Preventivo valido per 30 giorni. Pagamento anticipato richiesto.',
        },
        extractedData: {
            title: 'Dati strutturati estratti',
        },
        thread: {
            freightForwarderLabel: 'Freight Forwarder',
            shipperLabel: 'Shipper',
            carrierLabel: 'Armatore',
            bookingEmailBody: 'È stata generata una mail di richiesta booking all\'armatore sulla base di questa quote.',
            bookingCta: 'Lo shipper ha accettato il preventivo. Puoi richiedere il booking all\'armatore.',
            bookingRequested: 'Booking richiesto',
            bookingRequestAction: 'Richiedi booking all\'armatore',
            requestingBooking: 'Richiesta in corso...',
            requestingBookingMessage: 'Richiesta booking number al vettore in corso...',
            bookingNumberReceived: 'Booking number ricevuto',
            bookingNumber: 'Booking Number',
            simulateBookingNumber: 'Simula',
            sharingBookingNumber: 'Condivisione...',
            shareBookingNumber: 'Condividi booking number con Shipper',
            bookingShareSuccessTitle: 'Booking number condiviso con successo',
            bookingShareSuccessMessage: 'Il booking number è stato condiviso correttamente con lo Shipper. Riceverà una notifica e potrà visualizzare il booking number nella sezione Quote.',
            modificationRequestDefault: 'Richiesta di modifica del preventivo',
            acceptedMessage: 'Il preventivo è stato accettato.',
            rejectedMessage: 'Il preventivo è stato rifiutato.',
        },
    },
    processing: {
        currentStep: 'Elaborazione',
        steps: {
            analyzing: 'Analisi testo email',
            identifying: 'Identificazione prodotto',
            extracting: 'Estrazione dati strutturati',
            calculating: 'Calcolo costi',
            applying: 'Applicazione regole',
            generating: 'Generazione risposta',
        },
    },
    
    dashboard: {
        title: 'Dashboard',
        subtitle: 'Panoramica dei preventivi e statistiche',
        stats: {
            total: 'Totale Preventivi',
            pending: 'In Attesa',
            autoResponded: 'Risposta Automatica',
            requiresReview: 'Richiede Revisione',
            responded: 'Risposto',
            archived: 'Archiviato',
        },
        autoResponded: 'Risposta Automatica',
        manual: 'Manuale',
        charts: {
            statusDistribution: 'Distribuzione per Stato',
            autoVsManual: 'Risposta Automatica vs Manuale',
        },
        recentQuotes: {
            title: 'Preventivi Recenti',
            description: 'Ultime richieste di preventivo ricevute',
            viewAll: 'Visualizza Tutti',
        },
        noQuotes: 'Nessun preventivo disponibile',
    },
    
    settings: {
        title: 'Impostazioni Preventivi',
        subtitle: 'Configura regole, pricing e template email per la gestione automatica dei preventivi',
        tabs: {
            rules: 'Regole',
            pricing: 'Pricing',
            templates: 'Template Email',
        },
        
        rules: {
            title: 'Regole di Classificazione',
            description: 'Definisci regole in natural language per identificare e classificare le richieste di preventivo',
            create: 'Crea Regola',
            edit: 'Modifica Regola',
            deleteConfirm: 'Sei sicuro di voler eliminare questa regola?',
            active: 'Attiva',
            inactive: 'Inattiva',
            noRules: 'Nessuna regola configurata',
            naturalLanguageRule: 'Regola Natural Language',
            autoResponseConditions: 'Condizioni Risposta Automatica',
            form: {
                name: 'Nome Regola',
                namePlaceholder: 'Es. Regola Avocado',
                description: 'Descrizione',
                descriptionPlaceholder: 'Descrizione opzionale della regola',
                naturalLanguageRule: 'Regola Natural Language',
                naturalLanguageRulePlaceholder: 'Es. Identifica richieste per trasporto di avocado...',
                naturalLanguageRuleHint: 'Descrivi in linguaggio naturale come identificare questo tipo di richiesta',
                autoResponseConditions: 'Condizioni per Risposta Automatica',
                addCondition: 'Aggiungi Condizione',
                conditionPlaceholder: 'Es. se il prodotto richiesto è avocado',
                isActive: 'Regola attiva',
                isActiveLabel: 'Attiva questa regola per abilitare la classificazione automatica delle richieste',
            },
        },
        
        pricing: {
            title: 'Impostazioni Pricing',
            description: 'Configura buy rate, margin e sell rate components per il calcolo dei preventivi',
            create: 'Crea Impostazione',
            edit: 'Modifica Impostazione',
            deleteConfirm: 'Sei sicuro di voler eliminare questa impostazione?',
            noSettings: 'Nessuna impostazione configurata',
            default: 'Impostazione Default',
            buyRate: 'Buy Rate',
            margin: 'Margin',
            components: 'Componenti',
            componentsCount: 'componenti',
            sellRateComponents: 'Componenti Sell Rate',
            marginType: {
                percentage: 'Percentuale',
                currency: 'Valuta',
            },
            form: {
                buyRate: 'Buy Rate',
                baseCurrency: 'Valuta Base',
                marginValue: 'Valore Margin',
                marginType: 'Tipo Margin',
                sellRateComponents: 'Componenti Sell Rate',
                addComponent: 'Aggiungi Componente',
                component: 'Componente',
                componentName: 'Nome Componente',
                componentNamePlaceholder: 'Es. Costo carburante',
                componentValue: 'Valore',
                componentType: 'Tipo',
                componentDescription: 'Descrizione',
                componentDescriptionPlaceholder: 'Descrizione opzionale',
                noComponents: 'Nessun componente aggiunto',
            },
        },
        
        templates: {
            title: 'Template Email',
            description: 'Crea e modifica template email per le risposte automatiche ai preventivi',
            create: 'Crea Template',
            edit: 'Modifica Template',
            deleteConfirm: 'Sei sicuro di voler eliminare questo template?',
            noTemplates: 'Nessun template configurato',
            subject: 'Oggetto',
            body: 'Corpo',
            draftingInstructions: 'Istruzioni di Drafting',
            form: {
                name: 'Nome Template',
                namePlaceholder: 'Es. Template Avocado',
                subject: 'Oggetto Email',
                subjectPlaceholder: 'Es. Preventivo trasporto {{product}}',
                subjectHint: 'Usa {{variabile}} per inserire dati dinamici',
                body: 'Corpo Email',
                bodyPlaceholder: 'Inserisci il corpo dell\'email...',
                bodyHint: 'Usa {{variabile}} per inserire dati dinamici. Es. {{recipientName}}, {{totalPrice}}',
                draftingInstructions: 'Istruzioni di Drafting',
                addInstruction: 'Aggiungi Istruzione',
                instructionPlaceholder: 'Es. chiama il recipient per nome',
                noInstructions: 'Nessuna istruzione aggiunta',
                editTab: 'Modifica',
                previewTab: 'Anteprima',
                noPreview: 'Anteprima non disponibile',
            },
        },
    },
    
    shipper: {
        list: {
            loading: 'Caricamento richieste...',
            noRequests: 'Nessuna richiesta trovata',
            searchPlaceholder: 'Cerca richieste...',
            createNew: 'Crea Nuova Richiesta',
            title: 'Richieste di Preventivo Inviate',
            description: 'Lista delle richieste di preventivo inviate ai freight forwarder',
            edit: 'Modifica',
            view: 'Visualizza',
            cancel: 'Annulla',
            confirmCancel: 'Conferma Annullamento',
            confirmCancelMessage: 'Sei sicuro di voler annullare questa richiesta?',
            confirm: 'Conferma',
            filters: {
                allStatuses: 'Tutti gli stati',
            },
            headers: {
                subject: 'Oggetto',
                sentAt: 'Inviata il',
                recipients: 'Destinatari',
                responses: 'Preventivi Ricevuti',
                status: 'Stato',
                actions: 'Azioni',
            },
            recipientsCount: 'destinatari',
            responsesCount: 'preventivi',
        },
        status: {
            pending: 'In attesa',
            responded: 'Risposto',
            completed: 'Completato',
            cancelled: 'Annullato',
        },
        form: {
            createTitle: 'Crea Nuova Richiesta',
            editTitle: 'Modifica Richiesta',
            subject: 'Oggetto',
            subjectPlaceholder: 'Es. Richiesta preventivo trasporto...',
            body: 'Corpo Email',
            bodyPlaceholder: 'Inserisci il testo della richiesta di preventivo...',
            recipients: 'Destinatari (Freight Forwarder)',
            recipientsPlaceholder: 'Seleziona freight forwarder...',
            extractedDataTitle: 'Dati della Richiesta',
            send: 'Invia Richiesta',
            update: 'Aggiorna',
        },
        detail: {
            loading: 'Caricamento...',
            notFound: 'Richiesta non trovata',
            back: 'Indietro',
            sentAt: 'Inviata il',
            edit: 'Modifica',
            cancel: 'Annulla',
            confirmCancelMessage: 'Sei sicuro di voler annullare questa richiesta?',
            confirm: 'Conferma',
            requestDetails: 'Dettagli Richiesta',
            subject: 'Oggetto',
            body: 'Corpo Email',
            recipientsTitle: 'Destinatari',
            extractedData: 'Dati della Richiesta',
            receivedQuotes: 'Preventivi Ricevuti',
            tabs: {
                details: 'Dettaglio Richiesta',
                responses: 'Quote Ricevute',
            },
            confirmCancel: {
                title: 'Conferma Annullamento',
                message: 'Sei sicuro di voler annullare questa richiesta di preventivo?',
                confirm: 'Conferma',
            },
            checkingQuotes: 'Controllo nuove quote...',
            newQuotesAvailable: 'Nuove quote disponibili!',
            newQuoteReceived: 'Hai ricevuto una nuova risposta di preventivo',
            viewNewQuote: 'Visualizza nuova quote',
            readyToComplete: 'Puoi completare questa richiesta',
            readyToCompleteDescription: 'Ci sono una o più quote accettate. Puoi segnare la richiesta come completata e simulare la creazione di container basati su queste quote.',
            waitingForBookingNumber: 'In attesa del booking number',
            waitingForBookingNumberDescription: 'Devi attendere che almeno un Freight Forwarder condivida il booking number prima di poter completare la richiesta.',
            completeRequest: 'Completa richiesta',
            completeRequestTitle: 'Completa richiesta di preventivo',
            completeRequestMessage: 'La richiesta verrà segnata come completata. Il sistema simulerà la creazione di uno o più container sulla base delle quote accettate.',
            completeRequestConfirm: 'Conferma completamento',
            creatingContainer: 'Creazione container...',
            creatingContainerMessage: 'Stiamo creando il container sulla base delle quote accettate. Attendi...',
            recipients: {
                pending: 'In attesa',
                respondedAccepted: 'Accettato',
                respondedRejected: 'Rifiutato',
                respondedModified: 'Modifica richiesta',
                respondedAt: 'Risposto il',
                sendReminder: 'Invia sollecito',
                sendReminderTitle: 'Invia sollecito',
                sendReminderMessage: 'Vuoi inviare un sollecito a {{name}} ({{email}})?',
                sendingReminder: 'Invio in corso...',
                confirmSendReminder: 'Invia sollecito',
            },
        },
        responses: {
            noResponses: 'Nessun preventivo ricevuto ancora',
            selected: 'Selezionato',
            receivedAt: 'Ricevuto il',
            price: 'Prezzo',
            validity: 'Validità',
            days: 'giorni',
            viewDetails: 'Dettagli',
            complete: 'Imposta come Completato',
            detailsTitle: 'Dettagli Preventivo',
            from: 'Da',
            subject: 'Oggetto',
            body: 'Corpo Email',
            terms: 'Termini e Condizioni',
            accept: 'Accetta',
            reject: 'Rifiuta',
            requestModification: 'Richiedi Modifica',
            accepted: 'Accettata',
            rejected: 'Rifiutata',
            modificationRequested: 'Modifica Richiesta',
            actions: 'Azioni',
            confirmAcceptTitle: 'Conferma accettazione preventivo',
            confirmAcceptMessage: 'Sei sicuro di voler accettare questo preventivo? Potrai comunque accettare anche altre quote per tratte diverse della stessa spedizione.',
            confirmAcceptConfirm: 'Conferma accettazione',
            modificationEditorTitle: 'Richiesta modifica preventivo',
            modificationSubject: 'Oggetto',
            modificationBody: 'Testo richiesta modifica',
            modificationBodyPlaceholder: 'Descrivi le modifiche richieste (es. prezzo, condizioni, tempi)...',
            modificationSend: 'Invia richiesta modifica',
            modificationSubjectDefault: 'Richiesta modifica preventivo',
            thread: 'Thread Messaggi',
            originalQuote: 'Preventivo Originale',
            you: 'Tu',
            counterProposal: 'Controproposta',
            bookingNumber: 'Booking Number',
            bookingNumberRequested: 'Richiesta in corso...',
            bookingNumberShared: 'Il Freight Forwarder ha condiviso il booking number per questa quote accettata.',
            bookingNumberPending: 'Il Freight Forwarder sta richiedendo il booking number al vettore. Riceverai una notifica quando sarà disponibile.',
            received: 'Ricevuto',
            tabs: {
                thread: 'Thread',
                extractedData: 'Dati Estratti',
            },
        },
    },
};

